<div class="avu" role="alertdialog" aria-labelledby="avu-title" aria-describedby="avu-message">
  <header class="avu__header">
    <h2 id="avu-title" class="avu__title">Avyro just got better!</h2>
    <button
      type="button"
      class="ds-btn--close"
      aria-label="Close"
      (click)="dismiss()"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </header>
  <p id="avu-message" class="avu__message">
    Save your work and
    <button type="button" class="ds-btn ds-btn--link avu__link" (click)="refresh()">click here</button>
    to refresh to the latest version.
  </p>
  <div class="avu__actions">
    <button type="button" class="ds-btn ds-btn--primary" (click)="refresh()">
      Refresh
    </button>
  </div>
</div>
